import { render, staticRenderFns } from "./InvoiceCard.vue?vue&type=template&id=7b181d52&"
import script from "./InvoiceCard.vue?vue&type=script&lang=ts&"
export * from "./InvoiceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports